import { Check, Minus } from "@phosphor-icons/react";

const Y = <Check size={18} weight="bold" className="text-emerald-600 inline" aria-label="Included" />;
const N = <Minus size={18} className="text-rf-ink/30 inline" aria-label="Not included" />;

// Plain Free vs Single vs Family comparison (only features that are live today).
export const PlanComparison = ({ free }) => {
  const rows = [
    ["Saved recipes", `${free} recipes`, "Unlimited", "Unlimited for each person"],
    ["Cookbooks", "1 cookbook", "Unlimited", "Unlimited for each person"],
    ["Scans and previews", "Unlimited", "Unlimited", "Unlimited"],
    ["PDF export (A4 binder & book format)", Y, Y, Y],
    ["Share a shopping list view-only", Y, Y, Y],
    ["Live shared editing of lists", N, Y, Y],
    ["Share with chosen people or Family members", N, "Chosen people", "Chosen people and Family members"],
    ["Shared meal planner", N, Y, Y],
    ["Family seats", N, "Just you", "Up to 5 people"],
    ["How it renews", "Free, never expires", "£5 renews monthly, or £25 renews after 12 months", "£100 renews after 12 months"],
  ];
  return (
    <section className="mb-16" aria-labelledby="compare-heading" data-testid="pricing-comparison">
      <h2 id="compare-heading" className="font-display font-black text-3xl text-rf-ink mb-2">Compare plans</h2>
      <p className="text-rf-ink-soft mb-6" data-testid="pricing-invitees-free">People you invite to a shared list never need to pay. Cancel any time.</p>
      <div className="overflow-x-auto rounded-3xl border border-rf-ink/10 bg-white">
        <table className="w-full text-sm min-w-[640px]">
          <thead>
            <tr className="bg-rf-cream-alt text-left">
              <th scope="col" className="p-4 font-black">Feature</th>
              <th scope="col" className="p-4 font-black">Free (Taster)</th>
              <th scope="col" className="p-4 font-black">Single · £5/month or £25/year</th>
              <th scope="col" className="p-4 font-black">Family · £100/year</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(([label, ...cells]) => (
              <tr key={label} className="border-t border-rf-ink/10">
                <th scope="row" className="p-4 text-left font-semibold text-rf-ink">{label}</th>
                {cells.map((c, i) => <td key={i} className="p-4 text-rf-ink-soft">{c}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export const pricingJsonLd = (origin) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  name: "Recipe Filer subscription",
  description: "Family recipe app and family cookbook subscription: scan, save, share and print family recipes, with shared shopping lists and a family meal planner.",
  brand: { "@type": "Brand", name: "Recipe Filer" },
  url: `${origin}/pricing`,
  offers: [
    ["Single monthly", "5.00", "P1M"],
    ["Single annual", "25.00", "P1Y"],
    ["Family Plan (up to 5 people)", "100.00", "P1Y"],
  ].map(([name, price, dur]) => ({
    "@type": "Offer", name, price, priceCurrency: "GBP", availability: "https://schema.org/InStock", url: `${origin}/pricing`,
    priceSpecification: { "@type": "UnitPriceSpecification", price, priceCurrency: "GBP", billingDuration: dur },
  })),
});
